module.exports = __webpack_public_path__ + "img/fossil2Img1.8cb19ab4.jpg";